import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentLanguage } from '../features/langSlice';
import { useGetFaqsQuery } from '../features/contentsApiSlice';
import { FAQs, AnyOtherQuestion } from '../Constants/index';
import { useTranslation } from 'react-i18next';
import Loader from './elements/Loader';
import CustomLink from './CustomLink';
import { NewAccordion } from './Home/NewAccordion';
import ProductSuggestionWhyRiise from './Customer/ProductSuggestionWhyRiise';

const Faqs = () => {
  const selectedLang = useSelector(selectCurrentLanguage);
  const [lang, setLang] = useState();
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  const [skip] = useState(false);

  const { data: fetchFaqs, isSuccess, isLoading, refetch } = useGetFaqsQuery({ lang: lang, skip: skip });

  useEffect(() => {
    setLang(selectedLang === 'us' ? 'en' : selectedLang);

    refetch();
  }, [refetch, lang, selectedLang]);

  useEffect(() => {
    if (isSuccess) {
      setData(fetchFaqs.data);
    }
  }, [fetchFaqs, isSuccess]);

  return (
    <>
      <section className="t-flex t-flex-col t-min-h-[100px]">
        <div className="t-pt-6">
          <div className="container ">
            <nav aria-label="Page breadcrumb">
              <h2 className="title2 !t-text-[24px]">{t(FAQs)}</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  <CustomLink to={'/'} className="breadcrumb-item  !t-text-gray-500">
                    Home
                  </CustomLink>
                </li>
                <li className="breadcrumb-item  !t-text-gray-500">{t(FAQs)}</li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <section className="blog-details section-padding t-min-h-[100vh]">
        <div className="container t-flex t-flex-col t-gap-4">
          <div className="" defaultActiveKey="0">
            {data.map((item, index) => (
              <NewAccordion heading={item.title} key={`faq-${index}`} borderBottom>
                <p className="!t-m-0 !t-text-base !t-lowercase">{item.contents}</p>
              </NewAccordion>
            ))}
            <ProductSuggestionWhyRiise borderBottom />
          </div>

          <p className="!t-m-0 !t-mt-4">
            {t(AnyOtherQuestion)} <span className="!t-text-secondary">hi@weriise.co</span>
          </p>
        </div>
      </section>
      {isLoading && <Loader />}
    </>
  );
};

export default Faqs;
